export const DEFAULT_TRANSITION_DURATION = { enter: 400, exit: 10 };
export const AUTO_HIDE_DURATION = 3000;
